export const getNodeEnv = () => import.meta.env.MODE
export const inTestNodeEnv = () => getNodeEnv() === 'test'
export const inDevNodeEnv = () => getNodeEnv() === 'development'
export const inProdNodeEnv = () => getNodeEnv() === 'production'
export const inStorybook = () => !!import.meta.env.RUNNING_IN_STORYBOOK
export const inTestEnv = () => inTestNodeEnv() || inStorybook()
